import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
export function withConfirmation(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.abort = () => {
                const { resolve, cleanup } = this.props;
                this.setState({ show: false }, () => {
                    resolve(false);
                    cleanup();
                });
            };
            this.confirm = () => {
                const { resolve, cleanup } = this.props;
                this.setState({ show: false }, () => {
                    resolve(true);
                    cleanup();
                });
            };
            this.state = {
                show: true,
            };
        }
        render() {
            const { show } = this.state;
            return (_jsx(WrappedComponent, Object.assign({ show: show, abort: this.abort, confirm: this.confirm }, this.props)));
        }
    };
}
//# sourceMappingURL=withConfirmation.js.map